export { default } from '@klokhuis/modules/Commons/pages/RealEstateInsights/RealEstateInsights.page';
